import type { RouteLocationNormalizedLoaded, Router } from "vue-router"
import { searchStore } from "@/store/search"
import { Job } from "@/store/jobs"
import { nextTick } from "vue"

export async function navigateToJob(
    job: Job,
    route: RouteLocationNormalizedLoaded,
    router: Router
) {
    let target: { type: "client" | "project"; id: number } | null = null
    if (job.Project?.Id) {
        target = { type: "project", id: job.Project.Id }
    } else {
        const firstClientId = job.Clients?.[0]?.Id
        if (firstClientId && firstClientId !== 1) {
            target = { type: "client", id: firstClientId }
        }
    }
    if (!target) return

    searchStore().requestJobNavigation({
        type: target.type,
        entityId: target.id,
        jobId: job.Id,
    })

    const alreadyThere =
        route.query.page === target.type && Number(route.query.id) === target.id
    if (!alreadyThere) {
        await router.push({
            query: { ...route.query, page: target.type, id: String(target.id) },
        })
    }

    await nextTick()
    searchStore().requestJobPanelFocus()
}

/**
 * Клик по ссылке на клиента/проект работы (уведомление, «Информация о работе»):
 * сам переход делает router-link, а список работ на открывшейся странице
 * загрузится вокруг этой работы и подсветит её.
 * Клик с модификатором открывает ссылку в новой вкладке — тогда ничего не просим.
 * Возвращает true, если переход идёт в этой вкладке.
 */
export function requestJobHighlight(
    event: MouseEvent,
    type: "client" | "project",
    entityId: number,
    jobId: number
): boolean {
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
        return false
    }
    const store = searchStore()
    store.requestJobNavigation({ type, entityId, jobId })
    store.requestJobPanelFocus()
    return true
}
